import {
  GridItem,
  InverseHeader,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import { PhotoGrid } from '@/app/components/PhotoGrid';
import SectionHeading from '@/app/components/SectionHeading';

import {
  desktopPhotoGrid,
  mobilePhotoGrid,
} from './data/whyOuraDesignPhotoGrids';

const WhyOuraDesign = (): JSX.Element => {
  const t = useTranslations();
  return (
    <section
      className="relative pt-16 text-sandstone-500 lg:pb-16 lg:pt-32"
      data-cy="why-oura-design"
    >
      <LayoutGrid className="relative">
        <GridItem
          className="lg:pb-32"
          colEnd={{ sm: 'main', lg: 14 }}
          colStart={{ sm: 'main', lg: 'main' }}
        >
          <SectionHeading
            animated
            content="design_title"
            indentation="pl-[72px] lg:pl-28"
            multiline
            typographyProps={{
              className: 'leading-heading tracking-tighter',
              color: 'inherit',
              Element: 'h3',
              variant: 'h2',
            }}
          />
        </GridItem>
        <GridItem
          className="pb-12 pt-6 lg:pb-0"
          colEnd={{ sm: 'main', lg: 'main' }}
          colStart={{ sm: 'main', lg: 16 }}
        >
          <TypographyV3 color="inherit">{t('design_copy')}</TypographyV3>
        </GridItem>
        <GridItem
          className="overflow-hidden"
          colEnd={{ sm: 'full', md: 'main' }}
          colStart={{ sm: 'full', md: 'main' }}
        >
          <InverseHeader enter>
            <div className="md:hidden">
              <PhotoGrid {...mobilePhotoGrid} />
            </div>
            <div className="hidden md:block">
              <PhotoGrid {...desktopPhotoGrid} />
            </div>
          </InverseHeader>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default WhyOuraDesign;
